import { Responsive, Select, Switch } from '@cian/ui-kit';
import clsx from 'clsx';

import { WANT_KNOW_TYPE } from 'shared/constants/switcher';
import { EDealType } from 'shared/types/features';
import type { ISwitcherProps } from 'shared/types/switcher';

import * as styles from './Switcher.css';

export const Switcher: React.FC<ISwitcherProps> = ({
  device,
  title,
  isSuburbanSelected,
  onApartmentClick,
  onSuburbanClick,
  onOfferTypeSwitch,
  withDealType,
  dealType,
  onActiveDealType,
}) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['switcher-title']}>{title}</div>
      <div className={styles['switchers-body']}>
        {withDealType && (
          <Responsive desktop>
            <div className={styles['custom-switcher']}>
              {WANT_KNOW_TYPE.map(({ id, imgClass, text }) => (
                <div
                  key={id}
                  onClick={() => onActiveDealType?.(id)}
                  className={clsx(styles['custom-switcher-item'], id === dealType && styles['active'])}
                >
                  <div className={clsx(styles['image'], styles[imgClass])} />
                  <div className={styles['text']}>{text}</div>
                </div>
              ))}
            </div>
          </Responsive>
        )}
        <div className={styles['switch']}>
          <span className={styles['text']} onClick={onApartmentClick}>
            Квартиры
          </span>
          <Switch checked={isSuburbanSelected} onChange={onOfferTypeSwitch} />
          <span className={styles['text']} onClick={onSuburbanClick}>
            Дома
          </span>
        </div>
        {withDealType && (
          <Responsive tablet phone>
            <div>
              <Select
                width={260}
                size="M"
                options={WANT_KNOW_TYPE.map(item => ({ value: item.id, label: item.text }))}
                onChange={value => onActiveDealType?.(value as EDealType)}
                value={dealType}
              />
            </div>
          </Responsive>
        )}
      </div>
    </div>
  );
};
